export default {
    sideProjects: [
        {
            title: 'Markov Chains',
            subtitle: 'Python & Stochastic Processes',
            photo: require('../assets/coins.jpg'),
            alt: 'Coins for a probability problem',
            summary: 'Presented on the recurrent and transient properties of Markov Chains at the SUNY New Paltz Spring 2019 Symposium. Coded Python simulations of simple random walks on d-dimensional integer lattices in Jupyter Notebook.',
            tags: ['Python', 'Jupyter Notebook', 'Markov Chains'],
            source: 'https://github.com/oriordac/markov-chain-presentation',
            video: 'https://drive.google.com/file/d/1DDo-aHC3fiDfVuv67BXUSlDxN6cLFsH0/preview',
            site: 'https://github.com/oriordac/markov-chain-presentation/blob/master/Markov%20Chains%20Poster.pdf',
            id: 'markovChains',
            demo: 'markovDemo',
            get ariaDemo() { return `${this.id} ${this.demo}`},
            get ariaSource() {return `View the source code of ${this.title}`},
            get ariaSite() {return `View the presentation poster for ${this.title}`}
        },
        {
            title: 'Arminius the Turbulator',
            subtitle: 'Capstone History Paper',
            photo: require('../assets/hermannsdenkmal.jpg'),
            alt: 'Ernst von Bandel working on the hermannsdenkmal',
            summary: 'Built on Bootstrap. Recognized as the best seminar paper of the 2019 school year by the SUNY New Paltz History Department. Presented thesis at the Undergraduate Conference in German Studies at Lafayette College, PA.',
            tags: ['Bootstrap', 'Public Speaking'],
            source: 'https://github.com/oriordac/History-Seminar-Website',
            video: 'https://www.youtube.com/embed/8GilgTnKcO8',
            site: 'https://oriordac.github.io/History-Seminar-Website/index.html',
            id: 'ArminiusWebsite',
            demo: 'ArminiusDemo',
            get ariaDemo() { return `${this.id} ${this.demo}`},
            get ariaSource() {return `View the source code of ${this.title}`},
            get ariaSite() {return `View the live site for the ${this.title}`}
        }
    ]
}